import Vue from 'vue';
import LbButton from './button/lb-button.vue';
import LbCheckBox from './checkbox/lb-checkbox.vue'
import LbCheckBoxButton from './checkbox/lb-checkbox-button.vue'
import LbCheckBoxGroup from './checkbox/lb-checkbox-group.vue'
import LbDatePicker from './date-picker/lb-date-picker.vue';
import LbTimePicker from './time-picker/lb-time-picker.vue';
import LbSwitch from './switch/lb-switch.vue';
import LbLoading from './loading/lb-loading.vue';
import LbDialog from './dialog/lb-dialog.vue';
import LbTree from './tree/lb-tree.vue';
import LbDropdown from './dropdown/lb-dropdown.vue';
import LbDropdownMenu from './dropdown/lb-dropdown-menu.vue';
import LbDropdownItem from './dropdown/lb-dropdown-item.vue';
import LbBadge from './badge/lb-badge.vue';
import LbUpload from './upload/lb-upload.vue';
import LbTime from './time/lb-time.vue';
import LbFlexInput from './flex-input/lb-flex-input.vue';
import LbTimeline from './timeline/lb-timeline.vue';
import LbTimelineItem from './timeline/lb-timeline-item.vue';
import LbCollapse from './collapse/lb-collapse.vue';
import LbCollapseItem from './collapse/lb-collapse-item.vue';
import LbContainer from './container/lb-container.vue';
import LbVerificationCode from './verification-code/lb-verification-code.vue';
import LbCollapseMenu from './collapse-menu/lb-collapse-menu.vue';
import LbTableNav from './table-nav/lb-table-nav.vue';
import LbInput from './input/lb-input.vue';
import LbPagination from './pagination/lb-pagination.vue';
import LbRipple from './ripple/lb-ripple.vue';
import LbTag from './tag/lb-tag.vue';
import LbRadio from './radio/lb-radio.vue';
import LbRadioButton from './radio/lb-radio-button.vue';
import LbRadioGroup from './radio/lb-radio-group.vue';
import LbSelect from './select/select.vue';
import LbOption from './select/option.vue';
import LbOptionGroup from './select/option-group.vue';
import LbTab from './tabs/lb-tabs.vue';
import LbDrawer from './drawer/lb-drawer.vue';
import LbArea from './area/lb-area.vue';
import LbToolTip from './tooltip/lb-tooltip.vue';
import LbCalendar from './calendar/main.vue';
import LbRate from './rate/lb-rate.vue';
import LbSlider from './slider/lb-slider.vue';
import LbLink from './link/lb-link.vue';
import LbTable from './table/lb-table.vue';
import LbAutocomplete from './autocomplete/lb-autocomplete.vue';
import {
  TableColumn,
  TabPane,
  Popover,
} from 'element-ui';
import LbRow from './row/lb-row.vue';
import LbCol from './col/lb-col.vue';
import LbForm from './form/lb-form.vue';
import LbFormItem from './form/lb-form-item.vue';
import LbImg from './image/lb-img.vue';
import LbLogin from './login/lb-login.vue';
import LbSearch from './search/lb-search.vue';

const components = [
  LbArea,
  LbAutocomplete,
  LbContainer,
  LbCalendar,
  LbCollapseMenu,
  LbTag,
  LbTree,
  LbTimeline,
  LbVerificationCode,
  LbTimelineItem,
  LbLink,
  LbFlexInput,
  LbRow,
  LbCol,
  LbButton,
  LbToolTip,
  LbLoading,
  LbCheckBox,
  LbCheckBoxButton,
  LbCheckBoxGroup,
  LbRipple,
  LbRate,
  LbDatePicker,
  LbTimePicker,
  LbSwitch,
  LbDialog,
  LbDrawer,
  LbSlider,
  LbDropdown,
  LbDropdownMenu,
  LbDropdownItem,
  LbTableNav,
  LbUpload,
  LbForm,
  LbRow,
  LbCol,
  LbFormItem,
  LbInput,
  LbPagination,
  LbRadio,
  LbRadioButton,
  LbRadioGroup,
  LbSelect,
  LbTab,
  TabPane,
  LbTable,
  TableColumn,
  LbImg,
  LbBadge,
  LbOption,
  LbOptionGroup,
  LbLogin,
  LbTime,
  Popover,
  LbCollapse,
  LbCollapseItem,
  LbSearch
];

const install = (vue: typeof Vue): void => {
  components.forEach((component: any) => {
    if (component.name && component.name === 'ElTableColumn') {
      vue.component('lb-table-column', component);
    } else if (component.name && component.name === 'ElTabPane') {
      vue.component('lb-tab-pane', component);
    } else if (component.name && component.name === 'ElPopover') {
      vue.component('lb-popover', component);
    } else {
      // @ts-ignore
      vue.component(component.extendOptions ? component.extendOptions.name : component.name, component);
    }
  });
};
// @ts-ignore
if (typeof window !== 'undefined' && window.Vue) {
  // @ts-ignore
  install(window.Vue);
}

export default {
  install,
  ...components,
};
